// extracted by mini-css-extract-plugin
module.exports = {"dateInput":"styles_dateInput__d0K29"};